<template>
  <alertWrapper
    :iconsColor="theme.icons"
    :textColor="theme.text"
    :backgroundColor="theme.background"
    class="module module-alert padding_large"
    v-observe-visibility="visibilityChanged"
    :class="[
      { 'show-up': isVisible },
      baseAnimation,
      moduleClass,
      'theme-' + data.theme,
      'text-' + currentTheme().text_color
    ]"
  >
    <ModuleContainer>
      <div class="alert-icon">
        <span class="icon" v-html="svgIcons.alert" />
      </div>

      <div class="alert-main">
        <ModuleHeading :level="3">{{ data.alert_title }}</ModuleHeading>
        <LinksLine v-if="data.links" :data="data.links" />
      </div>
    </ModuleContainer>
  </alertWrapper>
</template>

<script>
import styled from "vue-styled-components";

const wrapperProps = {
  iconsColor: String,
  backgroundColor: String,
  textColor: String
};
const alertWrapper = styled("section", wrapperProps)`
  ${props =>
    props.backgroundColor && props.backgroundColor !== ""
      ? "background-color: " + props.backgroundColor
      : ""};
  ${props =>
    props.textColor && props.textColor !== ""
      ? "color:" + props.textColor
      : ""};
  ${props =>
    props.iconsColor && props.iconsColor !== ""
      ? " .alert-icon svg g, .links-line svg g{ fill: " + props.iconsColor + "}"
      : ""};
`;

import LinksLine from "@/components/blocks/LinksLine";

export default {
  name: "alert",
  props: ["data"],
  computed: {
    moduleClass() {
      let theme = "";
      if (this.data.theme === "gray") theme = "bg-gray";
      return theme;
    },
    theme() {
      if (this.data.theme === "accent") {
        return {
          background: this.currentTheme().select_color,
          text: this.currentTheme().text_color === "light" ? "#fff" : "#2A2E34",
          icons: this.currentTheme().text_color === "light" ? "#fff" : "#2A2E34"
        };
      } else {
        return {
          background: "",
          text: "",
          icons: this.currentTheme().select_color
        };
      }
    }
  },
  components: {
    LinksLine,
    alertWrapper
  }
};
</script>

<style lang="scss">
.module-alert {
  .html-content {
    white-space: pre-line;
  }
  &.theme-accent {
    &.text-dark {
      a {
        &:hover {
          color: #fff;
          ~ .icon svg g {
            fill: #fff;
          }
        }
      }
    }
    &.text-light {
      a {
        &:hover {
          color: #2a2e34;
          ~ .icon svg g {
            fill: #2a2e34;
          }
        }
      }
    }
  }
  .module-container {
    display: flex;
    max-width: 453px;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
  }
  .module-header {
    margin-bottom: 10px;
  }
  .links-line {
    margin-top: 0;
  }
  .alert-icon {
    margin-right: 20px;
    .icon {
      display: block;
    }
    svg {
      width: 56px;
      height: 56px;
    }
  }
}
</style>
